// @core/api/endpoints/form/attach_form.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AttachFormRequest,
  FormLifecycleResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Attach form to entity
 * Creates a form instance attached to any entity with form aspect. Uses the FormTypeDefinition to determine form template and settings. Publishes aspect.attached event.
 */
export async function AttachForm(
  target_type: string,
  target_id: string,
  data: AttachFormRequest,
  options?: RequestOptions
): Promise<FormLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/form/:target_type/:target_id/attach`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<FormLifecycleResponse>(requestPath, data, requestOptions);
}
